<template lang="html">

  <section class="buttons">
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <h4 class="h2">Logs</h4>
            <div>
              <select name="office" id="officeSelector" class="custom-select" v-model="selectedOffice" @change="onOfficeChange($event)">
                <option v-for="office in offices" v-bind:key="office.officeName" v-bind:value="office.value">{{office.officeName}}</option>
              </select>
              <div style="margin-top:25px" v-if="isLoading === true" class="circle-loader"></div>
            </div>
            <div style="margin-bottom: 10px; margin-top:10px"></div>
            <div>
              <select name="office" id="dateSelector" class="custom-select" v-model="selectedDate" @change="onDateChange($event)">
                <option v-for="date in dates" v-bind:key="date.dateName" v-bind:value="date.value">{{date.dateName}}</option>
              </select>
            </div>

            <div style="margin-top:24px">
              <form>
                <div class="form-group">
                  <label class="label">Totaal aantal gesprekken</label>
                  <div class="input-group" style="width:50%">
                    <input disabled type="text" class="form-control" v-model="total_number_of_calls" ref="total_number_of_calls" id="total_number_of_calls">
                  </div>
                </div>
                <div class="form-group">
                  <label class="label">Waarvan doorgeschakeld</label>
                  <div class="input-group" style="width:50%">
                    <input disabled type="text" class="form-control" v-model="number_of_calls_done" ref="number_of_calls_done" id="number_of_calls_done">
                  </div>
                </div>
                <div class="form-group">
                  <label class="label">Waarvan niet doorgeschakeld</label>
                  <div class="input-group" style="width:50%">
                    <input disabled type="text" class="form-control" v-model="number_of_calls_not_done" ref="number_of_calls_not_done" id="number_of_calls_not_done">
                  </div>
                </div>
              </form>
            </div>
          </div>

        </div>
      </div>
    </div>
  </section>

</template>

<script lang="js">
import Modal from '../modals/Modal'
import axios from 'axios'
import store from '../../store'
let server = require('../../server')

export default {
  name: 'buttons',
  components: {
    Modal
  },
  computed: {
    role () {
      return store.state.role
    },
    user () {
      return store.state.user
    },
    office () {
      return store.state.office
    },
    officeString () {
      return store.state.officeString
    }
  },
  async created () {
    let self = this
    try {
      let postData = {
        role: this.role,
        office: this.office
      }
      await axios({
        method: 'post',
        url: server.SERVER_URL + '/get_all_logs',
        data: postData
      })
        .then(function (response) {
          let data = response.data
          self.total_number_of_calls = data.total_number_of_calls
          self.number_of_calls_done = data.number_of_calls_done
          self.logs = response.data
          self.isLoading = false
        })
    } catch (e) {
      console.log('Error while trying to get users!')
      console.log(e)
    }
  },
  data () {
    return {
      logs: [],
      isLoading: false,
      offices: [
        {
          officeName: 'Alle kantoren',
          value: 0
        },
        {
          officeName: 'Sint-Truiden',
          value: 1
        },
        {
          officeName: 'Sint-Niklaas',
          value: 2
        },
        {
          officeName: 'Rumst',
          value: 3
        },
        {
          officeName: 'Pelt',
          value: 4
        },
        {
          officeName: 'Paal',
          value: 5
        },
        {
          officeName: 'Leuven',
          value: 6
        },
        {
          officeName: 'Herentals',
          value: 7
        },
        {
          officeName: 'Hasselt',
          value: 8
        },
        {
          officeName: 'Zaventem',
          value: 9
        },
        {
          officeName: 'Gent',
          value: 10
        }
      ],
      dates: [
        {
          dateName: 'Deze maand',
          value: 100
        },
        {
          dateName: 'Deze week',
          value: 101
        },
        {
          dateName: 'Vorige maand',
          value: 102
        },
        {
          dateName: 'Vorige week',
          value: 103
        },
        {
          dateName: 'Altijd',
          value: 104
        }
      ],
      selectedOffice: 0,
      selectedDate: 100,
      number_of_calls_done: '',
      number_of_calls_mislukt: '',
      number_of_calls_geen_antwoord: '',
      number_of_calls_antwoordapp: '',
      number_of_calls_oproep_mislukt: '',
      total_number_of_calls: '',
      number_of_calls_not_done: ''
    }
  },
  methods: {
    async getLogsByOfficeDate () {
      let self = this
      self.total_number_of_calls = '...'
      self.number_of_calls_done = '...'
      self.number_of_calls_not_done = '...'
      try {
        let postData = {
          office: this.selectedOffice,
          date: this.selectedDate
        }
        await axios({
          method: 'post',
          url: server.SERVER_URL + '/get_all_logs',
          data: postData
        })
          .then(function (response) {
            let data = response.data
            self.logData = data
            self.total_number_of_calls = data.total_number_of_calls
            self.number_of_calls_done = data.number_of_calls_done
            self.number_of_calls_not_done = data.number_of_calls_not_done
            console.log('logData = ')
            console.log(response.data)

            self.isLoading = false
          })
      } catch (e) {
        console.log('Error while trying to get users!')
        console.log(e)
      }
    },
    async onOfficeChange (event) {
      this.selectedOffice = event.target.value
      this.loading = true
      await this.getLogsByOfficeDate(this.selectedOffice, this.selectedDate)
    },
    async onDateChange (event) {
      this.selectedDate = event.target.value
      this.loading = true
      await this.getLogsByOfficeDate(this.selectedOffice, this.selectedDate)
    }
  }
}
</script>

<style scoped lang="scss">

.buttons {

}
</style>



// WEBPACK FOOTER //
// src/views/basic-elements/logs.vue